import loadable from '@loadable/component';

export const EditorTemplatesControlpanelView = loadable(
  () =>
    import(
      /* webpackChunkName: "plone-collecctive__volto-editortemplates" */ './controlpanel'
    ),
);
